import React from 'react';
import PropTypes from 'prop-types';
import { compose, prop } from 'ramda';
import { setPropTypes, withHandlers } from 'recompose';
import { FormattedNumber, FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import renderIf from 'app/enhancers/renderIf';
import S from 'app/features/billing/components/Plans/PlanItem.styled';
import Text from 'app/components/layout/Text.styled';
import Heading from 'app/components/layout/Heading.styled';
import { selectedPlanSku } from 'app/features/billing/selectors';
import { planBySku } from 'app/features/plans/selectors';
import { billingPlanSelected } from 'app/features/billing/actions';

const UI = ({
  plan: {
    title,
    sku,
    price: { currencyCode, amount, savings, monthlyCost },
  },
  onClick,
  selectedPlanSku,
}) => (
  <S.PlanItem
    savings={savings}
    className={`${selectedPlanSku === sku ? ' active' : ''}`}
    onClick={onClick}
    data-t={`select_plan_${title}`}
  >
    <Heading size="l" as={S.PlanItem.Title}>
      {title}
    </Heading>
    <h3>
      <Heading size="s" as="span">
        <FormattedNumber
          style="currency"
          currency={currencyCode}
          value={amount}
        />
      </Heading>
      <Text size="l" as={S.PlanItem.Subtitle} hasSavings={savings !== 0}>
        {savings === 0 ? (
          <FormattedMessage id="billing_plan_item_period">
            {text => `/${text}`}
          </FormattedMessage>
        ) : (
          <>
            <S.PlanItem.EqualSign>=</S.PlanItem.EqualSign>
            <FormattedNumber
              style="currency"
              currency={currencyCode}
              value={monthlyCost}
            />
            <FormattedMessage id="billing_plan_item_period">
              {text => `/${text}`}
            </FormattedMessage>
          </>
        )}
      </Text>
    </h3>
    {savings !== 0 && (
      <Text size="l" as={S.PlanItem.Savings} type="semibold">
        <FormattedMessage id="billing_plan_item_savings">
          {text => `${text} ${savings}%`}
        </FormattedMessage>
      </Text>
    )}
  </S.PlanItem>
);

UI.propTypes = {
  plan: PropTypes.shape({
    title: PropTypes.string,
    sku: PropTypes.string,
    price: PropTypes.shape({
      currencyCode: PropTypes.string,
      amount: PropTypes.string,
      savings: PropTypes.number,
      monthlyCost: PropTypes.number,
    }),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  selectedPlanSku: PropTypes.string,
};

UI.defaultProps = {
  selectedPlanSku: '',
};

UI.displayName = 'PlantItem';

const state = { plan: planBySku, selectedPlanSku };
const actions = { planSelected: billingPlanSelected };

const onClick = props => () => props.planSelected(props.plan);

const PlanItem = compose(
  setPropTypes({ sku: PropTypes.string.isRequired }),
  connect(state, actions),
  renderIf(prop('plan')),
  withHandlers({ onClick }),
)(UI);

export { UI };

export default PlanItem;
